import { Injectable } from '@angular/core';

export enum EventTopic {
  LoadScheduledEngagementsCompleted = 'LoadScheduledEngagementsCompleted',
  CurrentIncludedQuestionsUpdated = 'CurrentIncludedQuestionsUpdated',
  QuestionAnswerRemoved = 'QuestionAnswerRemoved',
  AuthFlowStateEventType = 'AuthFlowStateEventType',
  CurrentLocaleUpdated = 'CurrentLocaleUpdated',
}

@Injectable({
  providedIn: 'root',
})
export class EventBusService {
  private subscribers = [];
  private eventQueues = {};

  constructor() {}

  /**
   * publish the event
   *
   * @param t       EventTopic
   * @param o       event message (can be string, object, or anything)
   * @param queue   queue is used if the subscriber is not exist yet when event is published
   *                queued event will be consumed by the first subscriber if autoAck set to true.
   * @param autoAck if autoAck is false, the queue will remains until acknowledge is called
   *                max queue for each topic is 1, new event will replace old event with same topic
   */
  publish(t: EventTopic, o?: any, queue: boolean | 1 = false, autoAck = true) {
    if (this.subscribers[t.toString()]) {
      Object.values(this.subscribers[t.toString()]).forEach((subscriber: (o: any) => any) => {
        subscriber(o);
      });
    }
    if (queue) {
      this.eventQueues[t.toString()] = [{ obj: o, needAck: !autoAck }];
    }
  }

  addSubscriber<T = any>(t: EventTopic, subscriber: (o: T) => void, name: string) {
    if (!this.subscribers[t.toString()]) {
      this.subscribers[t.toString()] = {};
    }

    this.subscribers[t.toString()][name.toString()] = subscriber;

    // send event to subscriber if queue is exist
    if (this.eventQueues[t.toString()]) {
      let i = 0;
      while (this.eventQueues[t.toString()] && this.eventQueues[t.toString()].length > 0 && i < this.eventQueues[t.toString()].length) {
        const e = this.eventQueues[t.toString()][i.toString()];
        if (e && e.needAck) {
          subscriber(e.obj);
          i++;
        } else {
          this.eventQueues[t.toString()].shift();
          subscriber(e.obj);
        }
      }
    }
  }

  acknowledge(t: EventTopic) {
    delete this.eventQueues[t.toString()];
  }

  deleteSubscriber(t: EventTopic, name: string) {
    if (this.subscribers[t.toString()] && this.subscribers[t.toString()][name.toString()]) {
      delete this.subscribers[t.toString()][name.toString()];
    }
  }
}
